import { render } from "./DPhoneInput.vue?vue&type=template&id=165c0589"
import script from "./DPhoneInput.vue?vue&type=script&lang=js"
export * from "./DPhoneInput.vue?vue&type=script&lang=js"

import "./DPhoneInput.vue?vue&type=style&index=0&id=165c0589&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__